export default __webpack_public_path__ + "static/media/choose_location.2f4e3e9a.jpg";